"use strict";
/**
 * @author tatevik.marikyan
 * @since 02/07/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchicalDrillDownItem = /** @class */ (function () {
    /**
     * Model for each Hierarchical Drill Down Item
     * @param {Classifier} value
     * @param {MetaCategory} metaCategory
     * @param {string} metaFieldName
     */
    function HierarchicalDrillDownItem(value, metaCategory, metaFieldName, isRequired) {
        this.value = value;
        this.metaCategory = metaCategory;
        this.metaFieldName = metaFieldName;
        this.isRequired = isRequired;
    }
    return HierarchicalDrillDownItem;
}());
exports.HierarchicalDrillDownItem = HierarchicalDrillDownItem;
//# sourceMappingURL=hierarchical-drillDown-item.model.js.map